import { render, staticRenderFns } from "./assignment-completed-modal.vue?vue&type=template&id=31c4ea54&scoped=true"
import script from "./assignment-completed-modal.vue?vue&type=script&lang=js"
export * from "./assignment-completed-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-completed-modal.vue?vue&type=style&index=0&id=31c4ea54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c4ea54",
  null
  
)

export default component.exports